/**
 * DeepSeek Configuration
 *
 * DeepSeek exposes an OpenAI-compatible API. Models are prefixed with
 * "deepseek/" to route through DeepSeekProvider (mirrors grok.ts's pattern).
 */

export const DEEPSEEK_MODELS = {
  // Current default — the "Fastest" tier's model app-wide.
  DEEPSEEK_V4_FLASH: 'deepseek/deepseek-v4-flash',
  DEEPSEEK_V4_PRO: 'deepseek/deepseek-v4-pro',
};

export const DEFAULT_DEEPSEEK_MODEL = DEEPSEEK_MODELS.DEEPSEEK_V4_FLASH;

export const AVAILABLE_DEEPSEEK_MODELS = [
  {
    id: DEEPSEEK_MODELS.DEEPSEEK_V4_FLASH,
    name: 'DeepSeek V4 Flash',
    provider: 'deepseek',
    family: 'deepseek',
    description: 'Fast, efficient default Fastest tier',
    capabilities: ['text', 'reasoning'],
    tier: 'fast',
  },
  {
    id: DEEPSEEK_MODELS.DEEPSEEK_V4_PRO,
    name: 'DeepSeek V4 Pro',
    provider: 'deepseek',
    family: 'deepseek',
    description: 'Frontier coding and long-horizon agent quality',
    capabilities: ['text', 'reasoning'],
    tier: 'premium',
  },
];

/**
 * Check if a model ID is a DeepSeek model
 */
export function isDeepSeekModel(modelId: string): boolean {
  return modelId.startsWith('deepseek/');
}

/**
 * Get DeepSeek model name without prefix
 */
export function getDeepSeekModelName(modelId: string): string {
  return modelId.replace('deepseek/', '');
}
